import { Box } from '@mui/material'
import React from 'react'
import Header from 'components/Header'
import { CashBalanceTransactionSearchForm } from 'types/interfaces'
import update from 'immutability-helper'
import CashBalanceTransactionsTable from 'components/CashBalanceTransactionsTable'

const AdminCashBalanceTransactionList: React.FC = () => {
  const [cashBalanceTransactionSearchForm, setCashBalanceTransactionSearchForm] = React.useState<CashBalanceTransactionSearchForm>({})

  const updateCashBalanceTransactionSearchForm = React.useCallback((name: string, value: any) => {
    setCashBalanceTransactionSearchForm(update(cashBalanceTransactionSearchForm, { [name]: { $set: value } }))
  }, [cashBalanceTransactionSearchForm])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
      <Header text='Bank Transfer List' />
      <CashBalanceTransactionsTable
        form={cashBalanceTransactionSearchForm}
        updateForm={updateCashBalanceTransactionSearchForm}
      />
    </Box>
  )
}

export default AdminCashBalanceTransactionList